import { EventEmitter } from '@angular/core';

export class FooterActionBarButtonModel  {
    public name: string;
    // this is a style name used for primeng buttons and frequently used
    // as a terminology during ui design discussions
    public isPrimary: boolean;
    public isOutline: boolean;
    public click: EventEmitter<any>;
    public disabled: boolean;
    public visible: boolean = true;

    constructor(name: string, isPrimary: boolean, isOutline: boolean, disabled?: boolean) {
        this.name = name;
        this.isPrimary = isPrimary;
        this.isOutline = isOutline;
        this.click = this.click || new EventEmitter<any>();

        if (disabled) {
            this.disabled = disabled;
        }
    }
}


